import FileSaver from 'file-saver';
import XLSX from 'xlsx';
const exportTable = {
  // 导出excel
  exportExcel(id, excelName) {
    //方法接收两个参数：table表格的id, 导出的excel命名
    // 生成Excel工作簿对象
    var xlsxParam = { raw: true }; // 只导出不解析
    var wb = XLSX.utils.table_to_book(
      document.querySelector('#' + id),
      xlsxParam
    );
    // 获取二进制字符串作为输出
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      book: true,
      type: 'array',
    });
    try {
      FileSaver.saveAs(
        // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
        // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
        new Blob([wbout], { type: 'appliction/octet-stream' }),
        // 设置导出的文件名称
        `${excelName}` + '.xlsx'
      );
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout);
    }
    // 返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成。
    return wbout;
  },
  importExcel(e) {
    let file = e.file; // 文件信息
    // var tableData = [];
    // console.log('e: ', e);
    // console.log('file: ', e.file);

    if (!file) {
      return false;
    } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
      // 格式根据自己需求定义
      this.$message.error('上传格式不正确，请上传xls或者xlsx格式');
      return false;
    }

    const fileReader = new FileReader();
    fileReader.onload = (ev) => {
      try {
        const data = ev.target.result;
        const workbook = XLSX.read(data, {
          type: 'binary', // 以字符编码的方式解析
        });
        const exlname = workbook.SheetNames[0]; // 取第一张表
        const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容
        // 将 JSON 数据挂到 data 里
        // tableData = exl;
        // console.log(exl);
        // console.log(tableData);
        return exl;

        // document.getElementsByName('file')[0].value = '' // 根据自己需求，可重置上传value为空，允许重复上传同一文件
      } catch (e) {
        console.log('出错了：：');
        return false;
      }
    };
    fileReader.readAsBinaryString(file);
  },
};
export default exportTable;
